import React from 'react'

import { Title, Text } from 'components/typo'

import delve from 'dlv'

import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const KeyNumbers = ({ className, keyNumbers }) => {
  return (
    <ul className={cx(className, css.KeyNumbers)}>
      {keyNumbers.map((keyNumber, id) => {
        const text = delve(keyNumber, 'text')
        const number = delve(keyNumber, 'number')
        const shouldRender = text || number

        return shouldRender ? (
          <li key={id} className={css.keyNumber}>
            {number && (
              <Title tag="span" className={css.number} theme="purple">
                {number}
              </Title>
            )}
            {text && (
              <Text
                tag="span"
                className={css.text}
                theme="bay-blue"
                size="small"
              >
                {text}
              </Text>
            )}
          </li>
        ) : null
      })}
    </ul>
  )
}

export default KeyNumbers
